'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuCookies = require('@viskan/deku-cookies');

var _dekuCookies2 = _interopRequireDefault(_dekuCookies);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxageValidate = function maxageValidate(maxage) {
	var maxageParsed = parseInt(maxage, 10);

	if (Number.isInteger(maxageParsed)) {
		return maxageParsed * 86400000;
	}

	return 15552000000;
}; /** @jsx dom */


var render = function render(_ref) {
	var props = _ref.props;
	var bgColor = props.bgColor,
	    buttonBgColor = props.buttonBgColor,
	    buttonText = props.buttonText,
	    buttonTextColor = props.buttonTextColor,
	    cookieText = props.cookieText,
	    paddingHorizontal = props.paddingHorizontal,
	    paddingVertical = props.paddingVertical,
	    position = props.position,
	    textColor = props.textColor,
	    styleClasses = props.styleClasses;

	var msg = (0, _magicVirtualElement2.default)('div', { 'class': ['Cookies-text', styleClasses.Text], 'data-style-attr': 'Text', style: !styleClasses.Text && 'color: ' + textColor, innerHTML: cookieText });
	var btn = (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Cookies-button', styleClasses.Button], 'data-style-attr': 'Button', style: !styleClasses.Button && 'color: ' + buttonTextColor + '; background-color: ' + buttonBgColor },
		buttonText
	);
	var maxageValidated = maxageValidate(props.maxage);

	var styles = {
		'background-color': bgColor,
		'padding': paddingVertical + ' ' + paddingHorizontal
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CookiesMessage', 'CookiesMessagePosition--' + position, props.class, styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(_dekuCookies2.default, { button: btn, content: msg, maxage: maxageValidated, styles: styles, styleClasses: styleClasses })
	), props);
};

exports.default = { render: render };